/**
 * @module @/stores/root
 */

export * from './store'
